
import { Component, Inject, Vue } from "vue-property-decorator";
import FormMultiSelect from "../../../../landing/src/molecules/form/FormMultiSelect.vue";
import { SelectOption } from "../../../../landing/src/molecules/form/types";
import { Container } from "inversify";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";
import FormTreeselect from "../../../../landing/src/molecules/form/FormTreeselect.vue";
import { ProductTypeStore } from "../../../../common/src/stores/ProductTypeStore";
import { OrganizationFilterStore } from "../../stores/organization/OrganizationFilterStore";
import { ServiceTypeStore } from "../../../../common/src/stores/ServiceTypeStore";
import debounce from "debounce";
import { hasAccessToDashboard } from "../../../../common/src/utility/entity/user";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { SubscriptionQuoteModalStore } from "../../../../common/src/subscription-quote/SubscriptionQuoteModalStore";
import { handleError } from "../../../../common/src/utility/errorUtils";
import { event } from "vue-gtag";
import { MAX_FREE_ORGANIZATION_SEARCH } from "@gsx/common";

enum SearchType {
    Unknown = "unknown",
    Organizations = "organizations",
    Products = "products",
    Services = "services",
}

@Component({
    components: { FormTreeselect, FormMultiSelect },
})
export default class SearchBar extends Vue {
    @Inject("container") container!: Container;
    readonly organizationListStore: OrganizationListStore =
        this.container.get(OrganizationListStore);
    readonly organizationFilterStore: OrganizationFilterStore =
        this.container.get(OrganizationFilterStore);
    readonly productTypeStore: ProductTypeStore = this.container.get(ProductTypeStore);
    readonly serviceTypeStore: ServiceTypeStore = this.container.get(ServiceTypeStore);
    readonly authStore: AuthStore = this.container.get(AuthStore);
    readonly subscriptionQuoteModalStore: SubscriptionQuoteModalStore = this.container.get(
        SubscriptionQuoteModalStore,
    );

    searchType: SearchType = SearchType.Unknown;

    created() {
        this.productTypeStore.load().catch(handleError);
        this.serviceTypeStore.load().catch(handleError);
    }

    get SearchType() {
        return SearchType;
    }

    searchTypeChanged(e: any) {
        if (
            !this.subscribed &&
            e.target.value !== SearchType.Organizations &&
            e.target.value !== SearchType.Unknown
        ) {
            this.searchType = SearchType.Organizations;
            this.subscriptionQuoteModalStore.open();
        }
    }

    get organizationOptions(): SelectOption[] {
        const tracker = this.authStore.user!.organizationSearchTracker;
        let showOrgs = true;
        const orgs = (this.organizationListStore.items || []).map((organization) => ({
            id: organization.organizationid,
            name: organization.organizationName,
        }));

        if (tracker) {
            if (
                new Date(tracker.date).getMonth() === new Date().getMonth() &&
                tracker.count >= MAX_FREE_ORGANIZATION_SEARCH
            ) {
                showOrgs = false;
            }
        }

        return showOrgs ? orgs : [];
    }

    get productOptions() {
        return this.productTypeStore.item || [];
    }

    get productValues() {
        return [...this.organizationFilterStore.productTags.values()];
    }

    updateProductTags(values: string[]) {
        this.organizationFilterStore.productTags = new Set(values);
    }

    get serviceOptions() {
        return this.serviceTypeStore.item || [];
    }

    get serviceValues() {
        return [...this.organizationFilterStore.serviceTags.values()];
    }

    updateServiceTags(values: string[]) {
        this.organizationFilterStore.serviceTags = new Set(values);
    }

    navigateToOrganization(option: SelectOption) {
        this.$router.push(`/organizations/${option.id}`);
    }

    updateSearchDebounce = debounce(this.updateSearch, 600);

    updateSearch(query: string) {
        event("Search", {
            eventCategory: "Search",
            eventAction: "Search",
            eventLabel: "Search",
            eventValue: query as any,
        });
    }

    get subscribed(): boolean {
        return hasAccessToDashboard(this.authStore.user);
    }

    onSearchWrapperClick() {
        if (!hasAccessToDashboard(this.authStore.user)) {
            this.subscriptionQuoteModalStore.open();
        }
    }
}
